// extracted by mini-css-extract-plugin
export default {"advantages":"advantages_advantages__jAAqW","textContent":"advantages_textContent__DdvTS","imgContent":"advantages_imgContent__-iIwO"};